import { Component } from "@angular/core";

@Component({
  selector: "app-icon-user",
  imports: [],
  templateUrl: "./icon-user.component.html",
  styleUrl: "./icon-user.component.scss",
})
export class IconUserComponent {}
